import requests, { setToken } from "./httpServices";
import { showErrorAlert } from "./AlertService";


const TeacherServices = {

  getVideosWithQuiz: async (teacherId, includeAll = false) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      // Build query parameters
      const params = [];
      if (teacherId) params.push(`teacherId=${teacherId}`);
      if (includeAll) params.push(`all=true`);
      const queryString = params.length > 0 ? `?${params.join('&')}` : '';

      const response = await requests.get(`/quiz/get-videos-with-quiz${queryString}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      return response;


    } catch (error) {

      showErrorAlert(error);


      throw error;
    }
  },

  getAllTeachers: async (params) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get('school/get-all-school-teachers', { params });
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  getdashboardTeachers: async () => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get('school/school-dashboard');
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  schooledit: async (userdetials) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.put('/school/schooledit', userdetials);
      return response;
    } catch (error) {
      console.log(error, "errorr");
      showErrorAlert(error);
    }
  },

  getSchool: async (school_id) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get(`/school/${school_id}`);
      return response;
    } catch (error) {
      showErrorAlert(error);
    }
  },

  addSchoolTeacher: async (name, email, isSchoolAdmin = false) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.post('/school/add-school-teacher',
        { name, email, isSchoolAdmin },
        { headers: { "Content-Type": "application/json" } } // Force Header
      );
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  // ... (skipped parts)

  getTeacher: async (teacher_id) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get(`/school/getTeacher/${teacher_id}`);
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  updateTeacher: async (teacherData) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.put(`/school/updateTeacher`,
        teacherData,
        { headers: { "Content-Type": "application/json" } } // Force Header
      );
      return response;
    } catch (error) {
      showErrorAlert(error);
    }
  },

  deleteTeacher: async (teacherId) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);

      const response = await requests.delete(
        `/admin/delete-teacher/${teacherId}`
      );

      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  getCertificateTitles: async () => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get('/quiz/get-certificate-titles');
      return response;
    } catch (error) {
      console.error("Error fetching certificate titles:", error);
      // Return empty structure instead of throwing to prevent page crash
      return { certificates: [], quizdata: null };
    }
  },

  getCertificatesByTeacher: async (teacherId) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get(`/quiz/get-certificates-by-teacher/${teacherId}`);
      return response;
    } catch (error) {
      console.error("Error fetching certificates by teacher:", error);
      // Return empty structure instead of throwing to prevent page crash
      return { certificates: [], quizdata: null };
    }
  },

};

export default TeacherServices;